import type { ContentTableConfig } from "@gplibraries/react/components";
import { StringFormatter } from '@gplibraries/utils';

export const bargainWarehouseTableConfig: ContentTableConfig = {
  columns: {
    model_number: {
      label: 'Model #',
      data_type: 'link',
      headingStyles: {
        mobile: {
          width: '70px'
        }
      }
    },
    serial_number: {
      label: 'S/N',
      hideIfEmpty: true,
    },
    discount: {
      label: 'Discount Available',
      headingStyles: {
        mobile: {
          width: '100px'
        }
      },
      hideIfEmpty: true,
    },
    msrp: {
      label: 'MSRP',
      hideIfEmpty: true,
      render: (row) => row.msrp ? StringFormatter.currency(row.msrp) : null,
    },
    dealer_net: {
      label: 'Dealer Net',
      hideIfEmpty: true,
      render: (row) => row.dealer_net ? StringFormatter.currency(row.dealer_net) : null,
    },
    qty: {
      label: 'Qty Available',
      hideIfEmpty: true,
    },
    starting_bid: {
      label: 'Starting Bid',
      hideIfEmpty: true,
      render: (row) => row.starting_bid ? StringFormatter.currency(row.starting_bid) : null,

    },
    reserve: {
      label: 'Is Reserve Met',
      hideIfEmpty: true,
      render: (row) => row.reserve ? 'YES' : 'NO'
    },
    // details: {
    //   label: 'Details',
    // },
    // condition: {
    //   label: 'Condition of Unit',
    // },
    closing_date: {
      label: 'Closing Date (CST)',
      hideIfEmpty: true,
      render: (row) => row.closing_date ? new Date(row.closing_date).toLocaleDateString() : null,
    },
  }
}